import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { INTENT_PROJECT_UNLOCK } from "./gql";
import { SEARCH_INTENT_PROJECTS } from "../useSearchIntentProjects/gql";

const unlockIntentProjectHook = createDefaultMutationHook(INTENT_PROJECT_UNLOCK);

const useUnlockIntentProject = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [unlockMutation, { loading, error }] = unlockIntentProjectHook({
    refetchQueries: [SEARCH_INTENT_PROJECTS],
  });

  const unlockIntentProject = useCallback(
    async (id: string) => {
      unlockMutation({ id }, (data) => {
        if (data?.intentProjectUnlock) {
          reportSuccess({ message: "Intent project unlocked successfully." });
        }
      });
    },
    [unlockMutation, reportSuccess]
  );

  return {
    unlockIntentProject,
    loading,
    error,
  };
};

export default useUnlockIntentProject;
